export default "__VITE_ASSET__5d8da67e__"